/* eslint-disable class-methods-use-this */
import axios from 'axios';

import { getAuthToken } from './auth.service';

const headers = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET',
};

class GetHelper {
  async get(url: string, options?: Record<string, string>) {
    const response = await axios.get(url, { headers, ...options });
    return response;
  }
}

export default new GetHelper();
//{headers:{Authorization: `Bearer ${rawIdToken}`}